import "../style.css";
import { useState } from "react";
import { userContext } from "../../../context/usercontext";
import { Outlet } from "react-router-dom";
const UserPanel = () => {
  const [toggel, setToggel] = useState(true);
  const [requestStep, setRequestStep] = useState(1);
  const [estateInfo,setEstateInfo] = useState({})
  const [ownerInfo,setOwnerInfo] = useState({})
  const [expertInfo,setExpertInfo] = useState({})
  const [selectedEx,setSelectedExpert] = useState([])
  const [factorInfo,setFactorInfo] = useState([])

  return (
    <userContext.Provider
      value={{
        toggel,
        setToggel,
        requestStep,
        setRequestStep,
        estateInfo,
        setEstateInfo,
        ownerInfo,
        setOwnerInfo,
        expertInfo,
        setExpertInfo,
        selectedEx,
        setSelectedExpert,
        factorInfo,
        setFactorInfo
      }}
    >
      <div>
        <Outlet />
      </div>
    </userContext.Provider>
  );
};

export default UserPanel;
